import PropTypes from 'prop-types'
import { TextField } from '@mui/material'

import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { es } from 'date-fns/locale'

import { ReactComponent as CaretLeft } from '../../../assets/icons/caret-left.svg'
import { ReactComponent as CaretRight } from '../../../assets/icons/caret-right.svg'
import { ReactComponent as CalendarBlank } from '../../../assets/icons/calendar-blank.svg'

const DatePicker = ({
  value,
  inputProps = {},
  inputFormat,
  error,
  helperText,
  isRequired,
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <DesktopDatePicker
        views={['day']}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        inputProps={{ ...props }}
        components={{
          LeftArrowIcon: CaretLeft,
          OpenPickerIcon: CalendarBlank,
          RightArrowIcon: CaretRight,
        }}
        value={value}
        PopperProps={{ placement: 'bottom-start' }}
        PaperProps={{ elevation: 2 }}
        renderInput={params => (
          <TextField
            {...params}
            helperText={helperText}
            error={error ?? 'error'}
            InputLabelProps={{ required: isRequired }}
          />
        )}
        {...props}
      />
    </LocalizationProvider>
  )
}

DatePicker.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
  inputFormat: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  isRequired: PropTypes.bool,
}

export default DatePicker
